document.addEventListener('click', e => {
    if (!e.target.matches('.post-content__section-content p:has(img)') && !e.target.closest('.post-content__section-content p:has(img)')) return;

    const imgClone = e.target.querySelector('img').cloneNode();
    const div = document.createElement('div');

    div.classList.add('image-modal');
    div.appendChild(imgClone);
    div.setAttribute('data-target','close-modal');
    document.body.appendChild(div);
});

document.addEventListener('click', e => {
    if (!e.target.matches('[data-target="close-modal"]')) return;

    document.querySelector('.image-modal').remove();
});

